export default "__VITE_ASSET__bc39b3d9__"